import { Address } from '../Locations/LocationAddress'
import { IBillingContact } from './BillingContactModel'
import {
  ILegalEntityJSON,
  LegalEntitiesModel,
  LegalEntity,
  LegalEntityRegion,
  TLegalEntitiesModel,
  TLegalEntity,
} from './LegalEntitiesModel'

export const sampleLegalEntity: ILegalEntityJSON = {
  _id: '123',
  customerId: 'C123',
  name: 'name',
  organizationId: 'O123',
  eoriNumber: 'DE123456',
  vatId: '22222222',
  billingEntityId: 'BE-1234',
  billingAddress: {
    street: 'street1',
    streetNumber: '00',
    postalCode: '0000',
    city: 'test city',
    country: 'test country',
    countryCode: 'DE',
  } as Address,
  billingContact: {} as IBillingContact,
  notes: 'test the test',
  createdAt: '2018-08-23T12:41:13.269Z',
  updatedAt: '2018-08-23T12:41:13.269Z',
  hasVat: true,
  region: LegalEntityRegion.EU,
}

export function getLegalEntity(props?: Partial<ILegalEntityJSON>): TLegalEntity {
  const legalEntity = LegalEntity.create({ ...sampleLegalEntity, ...props })
  legalEntity.setHasValidVat(true)
  return legalEntity
}

export function getLegalEntitiesModel(): TLegalEntitiesModel {
  return LegalEntitiesModel.create({
    legalEntities: [sampleLegalEntity],
  })
}
